// extracted by mini-css-extract-plugin
module.exports = {"boldText":"DeleteHvacSopModal_boldText__hXdrS","marginTop":"DeleteHvacSopModal_marginTop__2t1u1","warningIcon":"DeleteHvacSopModal_warningIcon__2FQqo"};